// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__s6Hxa","header":"Error_header__drUN0","text":"Error_text__aHHte"};